
/**
 * Format date to a readable string
 */
export const formatDate = (dateString: string | undefined) => {
  if (!dateString) return 'Never';
  
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};
